<div id="body" class="body home-page">
    <div class="mobile-menu-background" [ngClass]="{'show': mobileMenuShow}">
        <div class="mobile-menu">
            <div class="header flex-container direction-row flex-between">
                <div class="logo" routerLink="/"> <img src="../../../../assets/mt/mtlogo_dark.svg" /> </div> 
                <div class="menu-button flex-container align-center" (click)="hideMenu()"><img src="../../../../assets/home/menu_open.svg" /></div>
            </div>
            <div class="button-list">
                <a *ngIf="hasAmbasador" class="header-menu-pricing" (click)="toPrice()" translate>Land.Pricing</a>
                <div *ngIf="hasAmbasador" class="menu-separator"></div>
                <a class="header-menu-contacts" (click)="toContacts()" translate>Land.Contacts</a>
                <div class="menu-separator"></div>
                <a class="header-menu-pricing" (click)="hideMenu()" routerLink="/privacy" translate>Land.Privacy</a>
                <div class="menu-separator"></div>
                <a class="header-menu-pricing" (click)="hideMenu()" routerLink="/tos" translate>Land.Terms</a>
                <div class="menu-separator"></div>
                <a class="header-menu-pricing" (click)="hideMenu()" routerLink="/help" translate>Land.Help</a>
                <div class="menu-separator"></div>
                <ul class="lang-list">
                    <li (click)="onLang(0)"><mat-icon [ngClass]="{'show':lang == 0}">check</mat-icon><span translate>Language.En</span></li>
                    <li (click)="onLang(1)"><mat-icon [ngClass]="{'show':lang == 1}">check</mat-icon><span translate>Language.Ua</span></li>
                    <li (click)="onLang(2)"><mat-icon [ngClass]="{'show':lang == 2}">check</mat-icon><span translate>Language.Ru</span></li>
                </ul>
                <div class="menu-separator"></div>
                <div class="flex-container direction-row align-items flex-center">
                    <div class="menu-signin"> <a *ngIf="hasAmbasador" class="header-menu-signin"  (click)="hideMenu(); toPrice();" translate>Login.SignUp</a></div>
                    <div class="menu-signin-separator"></div>
                    <div class="menu-signin"> <a (click)="hideMenu()" class="header-menu-signin" routerLink="/auth/signin" translate>Login.SignIn</a></div>
                </div>
            </div>
        </div>
    </div>
    <div class="mobile-header">
        <div class="header flex-container direction-row flex-between align-items">
            <div class="flex-container direction-row">
                <div class="logo" routerLink="/"> <img src="../../../../assets/mt/mtlogo_dark.svg" /> </div>
                <div class="logo ambasador" *ngIf="hasAmbasador && ambasador.logoKey"> <img src="../../../../assets/ambassador/{{ambasador.logoKey}}" /> </div>
            </div>
            <div class="header-menu">
                <a *ngIf="hasAmbasador" class="header-menu-pricing" (click)="toPrice()" translate>Land.Pricing</a>
                <a class="header-menu-contacts" (click)="toContacts()" translate>Land.Contacts</a>
                <a class="header-menu-pricing" routerLink="/privacy" translate>Land.Privacy</a>
                <a class="header-menu-pricing" routerLink="/tos" translate>Land.Terms</a>
                <a class="header-menu-help" routerLink="/help" translate>Land.Help</a>
            </div>
            <div class="menu-button flex-container align-center" (click)="mobileMenuShow=true"><img src="../../../../assets/home/menu_closed.svg" /></div>
            <div class="buttons-list">
                <div class="menu-signin">
                    <a class="header-menu-signin" routerLink="/auth/signin" translate>Login.SignIn</a>
                    <a *ngIf="hasAmbasador" class="header-menu-signin" (click)="toPrice();"  translate>Login.SignUp</a>
                </div>
                <div class="language">
                    <ul>
                        <li>
                            <a class="selected-lang"><mat-icon>language</mat-icon><span translate>Language.{{langs[lang]|titlecase}}</span></a>
                            <ul class="lang-list">
                                <li (click)="onLang(0)"><mat-icon [ngClass]="{'show':lang == 0}">check</mat-icon><span translate>Language.En</span></li>
                                <li (click)="onLang(1)"><mat-icon [ngClass]="{'show':lang == 1}">check</mat-icon><span translate>Language.Ua</span></li>
                                <li (click)="onLang(2)"><mat-icon [ngClass]="{'show':lang == 2}">check</mat-icon><span translate>Language.Ru</span></li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>


        </div>

    </div>

    <router-outlet></router-outlet>

</div>
<consent></consent>
